// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { isPlanLimitError } from '@/account/utilities/is-plan-limit-error';
import { ERROR_MESSAGES } from '@/api/constants';
import { useToast } from '@/contexts/toast-context';
import { Box } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

/** Shows the trial-limit toast whenever a free plan limit refuses a mutation. */
export function PlanLimitToastListener() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();

  useEffect(() => {
    return queryClient.getMutationCache().subscribe((event) => {
      if (event.type !== 'updated' || event.action.type !== 'error') {
        return;
      }

      if (!isPlanLimitError(event.action.error)) {
        return;
      }

      showToast({
        severity: 'warning',
        element: <Box>{ERROR_MESSAGES.plan_limit_exceeded}</Box>,
      });
    });
  }, [queryClient, showToast]);

  return null;
}
